import { theme } from '@frontend/theme';

export const CONTAINER_HEIGHT = `calc(100vh - ${theme.spacing(29)})`;
